module.exports = __webpack_public_path__ + "img/bitshake-script.e960ae88.png";